export default __webpack_public_path__ + "static/media/beraksi-phone5.0fc9a4e6.png";